import appGlobal from '@/appGlobal';
import BaseIconSvg from '@/components/bases/BaseIconSvg';
import { TYPE_POST_MESSAGE } from '@/hooks/useMessageWebview';
import utils from '@/utils';
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const PHRNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { title } = location?.state ?? { title: 'Hồ sơ sức khoẻ cá nhân' };

  const onPress = () => {
    const showBack =
      !appGlobal.isWebview ||
      ['records-by-type', 'detail', 'logs', 'medical-records'].includes(location.pathname.split('/')[2]);
    if (showBack) {
      navigate(-1);
    } else {
      utils.postMessage({
        type: TYPE_POST_MESSAGE.CLOSE_VIEW,
        data: true,
      });
    }
  };

  return (
    <div className="flex flex-none flex-row items-center h-[52px] bg-mint-9 px-4 sticky z-10">
      <button className="pl-0 pr-2 h-[32px] bg-transparent" onClick={onPress}>
        <BaseIconSvg src="/icons/Regular/Back - icon.svg" className="text-white" />
      </button>
      <p className="text-white cms-h3 uppercase">{title ? title : 'Hồ sơ sức khoẻ cá nhân'}</p>
    </div>
  );
};

export default PHRNav;
